import type { AxiosError } from 'axios'

export enum PromoPlanErrorCode {
  WindowOverlap = 'WindowOverlap',
  ActivePlanNoEndDate = 'ActivePlanNoEndDate',
  ScheduledPlanAlreadyExists = 'ScheduledPlanAlreadyExists',
  NewPlanOverlapsScheduledPlan = 'NewPlanOverlapsScheduledPlan',
  PlanNotFound = 'PlanNotFound',
  PlanAlreadyApplicable = 'PlanAlreadyApplicable',
  PlanNotYetActive = 'PlanNotYetActive',
  PlanAlreadyEnded = 'PlanAlreadyEnded',
  ActivationDateFrozen = 'ActivationDateFrozen',
  ActivationDateInPast = 'ActivationDateInPast',
  EndDateInPast = 'EndDateInPast',
}

interface BusinessExceptionBody {
  message: string
  errorCode?: string
  type: string
}

export const getPromoPlanErrorCode = (descriptor: { raw: unknown }): string | undefined =>
  (descriptor.raw as AxiosError<BusinessExceptionBody>)?.response?.data?.errorCode
